/**
 * AttentionList: Suspect sites, busiest first, each with a link and "Show on map".
 */
import { Link } from 'react-router-dom';
import type { SiteMapEntry } from '../models/siteMapModels';
import { entryHealthDetail, formatShotCount } from '../utils/siteMapPresentation';

interface AttentionListProps {
  /** Already filtered and ordered (see attentionList) */
  readonly entries: readonly SiteMapEntry[];
  readonly searchString: string;
  readonly onShowOnMap: (siteId: string) => void;
  readonly onOpen: (siteId: string) => void;
}

export function AttentionList({
  entries,
  searchString,
  onShowOnMap,
  onOpen,
}: AttentionListProps): JSX.Element {
  return (
    <section className="site-map-panel__section" aria-labelledby="site-map-attention-heading">
      <h2 id="site-map-attention-heading" className="site-map-panel__heading">
        Needs attention
      </h2>
      {entries.length === 0 ? (
        <p className="site-map-panel__muted">No sites currently need attention.</p>
      ) : (
        <ul className="site-map-attention">
          {entries.map((entry) => (
            <li key={entry.site.siteId} className="site-map-attention__item">
              <div className="site-map-attention__text">
                <Link
                  to={`/site/${encodeURIComponent(entry.site.siteId)}${searchString}`}
                  className="site-map-attention__name"
                  onClick={() => onOpen(entry.site.siteId)}
                >
                  {entry.site.name}
                </Link>
                <span className="site-map-attention__reasons">{entryHealthDetail(entry)}</span>
                <span className="site-map-attention__shots">
                  {formatShotCount(entry.health?.recentShots ?? 0)} recently
                </span>
              </div>
              <button
                type="button"
                className="site-map-button site-map-button--secondary"
                onClick={() => onShowOnMap(entry.site.siteId)}
                aria-label={`Show ${entry.site.name} on map`}
              >
                Show on map
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
